<script>
import Collapse from '@/components/atoms/Collapse'
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox'
import { mapGetters } from 'vuex'
export default {
    name: 'TagBox',
    components: { InputCheckbox, Collapse },
    props: {
        group: null,
        disabled: Boolean,
    },
    data() {
        return {
            showMore: false,
            limit: 5,
        }
    },
    computed: {
        ...mapGetters(['smDevice', 'locale']),
        selectedInGroup() {
            return this.group?.items.filter((item) => this.selectedTags.includes(item.slug))
        },
        selectedTags: {
            get() {
                let tags = this.$route.query.tag_names
                return tags && tags.length >= 0
                    ? typeof tags === 'string'
                        ? [tags]
                        : tags.map((tag) => tag)
                    : []
            },
            set(val) {
                this.setQuery(
                    { tag_names: val && val.length ? val : undefined },
                    'restaurant-list',
                    {
                        pageLoader: false,
                    },
                    () => {}
                )
            },
        },
        showIndex() {
            return this.group?.items.reduce((p, c, index) => {
                if (
                    !!this.selectedInGroup.find((filter) => filter.slug === c.model.slug) &&
                    index + 1 > this.limit
                )
                    return p - 1
                return p
            }, this.limit)
        },
    },
    methods: {
        toggleMore() {
            this.showMore = !this.showMore
        },
        setSelectedTags(value) {
            this.selectedTags = value
        },
    },
}
</script>

<template lang="pug">
lazy-component.tag-box(v-if="!smDevice")
    hr
    collapse.no-bg(open-on-load)
        template(v-slot:header)
            h3.my-0 {{group.tag_group.name_token}}
        input-checkbox.w-100.my-2.py-1(
            v-for="(filter, index) in group.items" :key="`filter-${index}`"
            v-show="(!showMore && selectedTags.includes(filter.slug)) || index < limit"
            :value="selectedTags"
            @input="setSelectedTags"
            :disabled="disabled"
            :data="filter.slug")
            | {{filter.name_token}}
            span.ml-2.text-b2.text-sm
        collapse.no-bg.mb-0(v-if="group.items.length > limit" :value="showMore" slim)
            input-checkbox.w-100.my-2.py-1(
                v-for="(filter, index) in group.items"  
                v-if="index >= limit" 
                v-model="selectedTags" 
                :disabled="disabled" 
                :data="filter.slug" 
                :key="`filter-${index}`")
                | {{filter.name_token}}
                span.ml-2.text-b2.text-sm
        button.btn.btn-link.text-73.btn-xs.font-size-sm.px-0(@click="toggleMore" v-if="group.items.length > 5")
            template(v-if="showMore") {{$t('restaurant.show_less')}}
            template(v-else) {{$t('restaurant.show_all', {group: group.tag_group.name_token})}}
</template>
